import React, { useState } from 'react';
import './footer.css';
import Waves from '../waves/Waves';
import SplashCursor from '../splashCursor/SplashCursor';
import { LuEgg, LuEggFried } from "react-icons/lu";

const Footer = () => {
const [isEggActive, setIsEggActive] = useState(false);

const handleEggClick = () => {
    setIsEggActive((prev) => !prev); // Toggle state
};

return (
    <footer className='footer'>
    {/* Waves sebagai background */}
    <div className="waves">
        <Waves
        lineColor="#a1a1a1"
        backgroundColor="rgba(255, 255, 255, 0.2)"
        waveSpeedX={0.02}
        waveSpeedY={0.01}
        waveAmpX={40}
        waveAmpY={20}
        friction={0.9}
        tension={0.01}
        maxCursorMove={120}
        xGap={12}
        yGap={36}
        />
    </div>

    <div className="footer__container container">
        <h1 className="footer__title" data-aos="zoom-in-up">Nandi Rifaldi</h1>
        <ul className="footer__list">
        <li><a href="#about" className="footer__link" data-aos="zoom-in-up" data-aos-delay="200">About</a></li>
        <li><a href="#portfolio" className="footer__link" data-aos="zoom-in-up" data-aos-delay="300">Portfolio</a></li>
        <li><a href="#testimonials" className="footer__link" data-aos="zoom-in-up" data-aos-delay="400">Testimonials</a></li>
        </ul>

        <div className="footer__social">
        <a href="https://instagram.com/nxndi_rfld" className="footer__social-link" data-aos="zoom-in" data-aos-delay="200" target="_blank" rel="noopener noreferrer">
            <i className="bx bxl-instagram"></i>
        </a>
        <a href="https://github.com/nxndi" className="footer__social-link" data-aos="zoom-in" data-aos-delay="300" target="_blank" rel="noopener noreferrer">
            <i className="bx bxl-github"></i>
        </a>
        <a href="https://www.linkedin.com/in/nandi-rifaldi-529b542b3?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" className="footer__social-link" data-aos="zoom-in" data-aos-delay="400" target="_blank" rel="noopener noreferrer">
            <i className="bx bxl-linkedin"></i>
        </a>
        </div>

        {/* Tombol Egg untuk mengaktifkan SplashCursor */}
        <div className="footer__egg" data-aos="zoom-in" data-aos-delay="500">
        <button className="footer__egg-button" onClick={handleEggClick}>
            {isEggActive ? <LuEggFried size={24} /> : <LuEgg size={24} />}
        </button>
        </div>

        <span className="footer__copy">&#169; Nxndi. All rights reserved</span>
    </div>

    {/* SplashCursor hanya aktif jika isEggActive true */}
    {isEggActive && <SplashCursor />}
    </footer>
);
};

export default Footer;
